import {useSortable} from '@dnd-kit/sortable';
import clsx from 'clsx';
import {FC, HTMLAttributes} from 'react';

type SortableHandlerProps = {
    disabled?: boolean;
    id: string;
} & HTMLAttributes<HTMLDivElement>;

const SortableHandler: FC<SortableHandlerProps> = ({
    children,
    className,
    disabled,
    id,
    ...buttonProps
}) => {
    const {listeners, setActivatorNodeRef} = useSortable({
        disabled,
        id,
    });

    return (
        <div
            className={clsx('cursor-grab', className)}
            ref={setActivatorNodeRef}
            {...buttonProps}
            {...listeners}
        >
            {children}
        </div>
    );
};

export default SortableHandler;
